export const ECOSYSTEM_QUERY_KEYS = {
  SEARCH: [ 'ecosystem', 'search' ],
  DETAIL: [ 'ecosystem', 'project', 'detail' ],
  SORT_LIST: [ 'ecosystem', 'project', 'sort', 'list' ],
  CATEGORY_LIST: [ 'ecosystem', 'project', 'category', 'list' ],
  GENERAL: [ 'ecosystem', 'general' ],
  FEATURED: [ 'ecosystem', 'featured' ],
  DEFI_DASHBOARD_LIST: [ 'ecosystem', 'defi', 'dashboard', 'list' ],
  DEFI_CATEGORY_LIST: [ 'ecosystem', 'defi', 'category', 'list' ],
  DEFI_CHART: [ 'ecosystem', 'defi', 'chart' ],
}